export const sectionConfig = {
  "suptitle": "تعهد ما به شما",
  "title": "چرا برای ما اعتبار شما همه چیز است؟",
  "caption": "ما معتقدیم شما لایق تجربه‌ای شفاف، عادلانه و بدون محدودیت‌های بیهوده هستید.",
  "items": [
    { "label": "اعتبار شما هرگز منقضی نمی‌شود؛ تا آخرین توکن برایتان باقیست." },
    { "label": "پرداخت تنها به اندازه مصرف؛ عادلانه، شفاف و بدون هزینه اضافه." },
    { "label": "دسترسی مستقیم و واقعی به برترین مدل‌های هوشمند جهان." },
    { "label": "همیشه پیشرو؛ اولین ارائه دهنده مدل‌های جدید در ایران." }
  ]
}